import axios from 'axios'
import store from '../store/main'

axios.custom = {
    apiPath: '/api',
    entityId: (entity, id) => {
        return axios.custom.apiPath + '/' + entity + '/' + id;
    },
    changeLang: (lang) => {
        axios.defaults.headers.post['Accept-Language'] = lang
    },
}

axios.defaults.baseURL = process.env.VUE_APP_API_URL + axios.custom.apiPath + '/'
axios.defaults.headers.post['Content-Type'] = 'application/ld+json'

axios
    .interceptors.request.use(
    function (config) {
        // Do something before request is sent

        function getOSParam() {
            const urlParams = new URLSearchParams(window.location.search)
            return urlParams.get('os')
        }

        if (getOSParam() === "ios") {
            localStorage.setItem('isIosApp', 'true')
        }

        config.headers.post['Accept-Language'] = window.i18n.locale
        config.headers.common['Authorization'] = 'Bearer ' + store.getters.getAccessToken

        return config;
    },
    function (error) {
        // Do something with request error
        console.log("interceptor")
        console.log(error)
        return Promise.reject(error);
    });

axios
    .interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        console.log("response")
        console.log(response)
        return response;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error

        console.log("error: status, url, data")

        if (error.response === undefined) {
            return Promise.reject('connectionRefused');
        }

        console.log(error.response.status)
        console.log(error.config.url)
        console.log(error.response.data)

        if (error.response.status === 401 && (error.config.url !== '/users/auth' || error.config.url !== '/users/auth/refreshToken')) {
            console.log('need to clean token')
            store.dispatch('fetchRefreshToken')
                .catch(() => {
                    store.dispatch('clearTokens').then(() => {
                        if (
                            window.i18nHelper.getCurrentRoute().name !== 'login' &&
                            window.i18nHelper.getCurrentRoute().name !== 'forgot' &&
                            window.i18nHelper.getCurrentRoute().name !== 'reset' &&
                            window.i18nHelper.getCurrentRoute().name !== 'plans/compare'

                        ) {
                            window.i18nHelper.toUrl('login')
                        }
                    })
                })
        }

        return Promise.reject(error);
    });

export default axios
